import { parse } from 'csv-parse/browser/esm/sync';

const CSVInput = ({ setLoadFile, skipLines, parseErrorCb }) => {
	const handleFile = (event) => {
		const file = event.target.files?.[0];

		if (!file) {
			setLoadFile(null);
			return;
		}

		const reader = new FileReader();

		reader.onload = () => {
			const result = reader.result;

			const lines = result.split(/\r?\n/);
			const cleanedCsvToParse = lines.slice(skipLines).join('\n');

			try {
				const records = parse(cleanedCsvToParse, {
					columns: true,
					skip_empty_lines: true,
				});
				setLoadFile(records);
			} catch {
				parseErrorCb?.();
			}
		};

		reader.onerror = () => {
			console.error('File read error');
			setLoadFile(null);
		};

		reader.readAsText(file);
	};

	return (
		<input
			type='file'
			accept='.csv,text/csv'
			className='csv-reader-input'
			style={{ color: 'red' }}
			onChange={handleFile}
		/>
	);
};

export default CSVInput;
